import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subtitle", "disabled", "align"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Selector/SelectorBody.js",
    _this = this;

import React from 'react';
import { Body, BodyTitle, BodySubtitle } from './style';

var SelectorBody = function SelectorBody(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      disabled = _ref.disabled,
      align = _ref.align,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Body, _extends({
    align: align
  }, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 5
    }
  }), title && /*#__PURE__*/React.createElement(BodyTitle, {
    disabled: disabled,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 17
    }
  }, title), subtitle && /*#__PURE__*/React.createElement(BodySubtitle, {
    disabled: disabled,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 20
    }
  }, subtitle), rest.children);
};

export default SelectorBody;